import React, { useContext, useState, useEffect } from "react";
import Select from 'react-select';
import ReactTimeAgo from 'react-time-ago';
import { ContentContext } from "../content/ContentContext";
import "../../Forum.css";
import MyGallery from "../imageGallery/ImageGallery";
import { Stack, Badge, Tooltip, OverlayTrigger } from "react-bootstrap";
import MyCommentsSection from "../commentsSection/MyCommentsSection";
import { useUser } from "../loggedUserContext/LoggedUserContext";
import LikeButton from "../likebutton/LikeButton";
import 'react-notifications/lib/notifications.css';
import { NotificationContainer, NotificationManager } from 'react-notifications';

const PostDetails = () => {
  const { selectedPostId, setContent } = useContext(ContentContext);
  const [postDetailsData, setPostDetailsData] = useState(null);
  const [userProfile, setUserProfile] = useState(null);
  const { userId } = useUser();
  const [hasCommented, setHasCommented] = useState(false);
  const [isProcessing, setIsProcessing] = useState(false);
  const [loggedUserData, setLoggedUserData] = useState(null);
  const [options, setOptions] = useState([]); // State for tag options

  const handleToggle = () => {
    setContent("PostList");
  };

  const encodeUserId = (userId) => {
    const salt = "6312241f4b246734bbfd5e9ed9120cd7fb64dc6020ef66c2e7f124a5bb1d3d25";
    return btoa(userId + salt); // Base64 encode the user ID with the salt appended
  };

  const handleUserClick = () => {
    const encodedUserId = encodeUserId(userProfile.id_user);
    const url = `https://4construct.ro/homepage/index.php?p=utilizator&id=${encodedUserId}`;
    window.location.href = url;
  };

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/tags`)
      .then(response => response.json())
      .then(data => {
        const tagOptions = data.map(tag => ({
          value: tag.tag,
          label: tag.tag
        }));
        setOptions(tagOptions);
      })
      .catch(error => {
        console.error('Error fetching tags:', error);
      });
  }, []);

  const handleTagChange = (tag, selectedOption) => {
    setIsProcessing(true);

    let endpoint = '';
    let body = {};
    let method = '';

    if (selectedOption.value === 'delete') {
      endpoint = `${process.env.REACT_APP_API_URL}/tags/delete`;
      body = { tag, postId: selectedPostId };
      method = 'DELETE';
    } else if (selectedOption.value === 'change') {
      endpoint = `${process.env.REACT_APP_API_URL}/tags/change`;
      body = { oldTag: tag, newTag: selectedOption.label, postId: selectedPostId };
      method = 'PUT';
    } else {
      endpoint = `${process.env.REACT_APP_API_URL}/tags/approve`;
      body = { tag, postId: selectedPostId };
      method = 'POST';
    }

    fetch(endpoint, {
      method: method,
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body),
    })
      .then((response) => {
        if (!response.ok) throw new Error(`Failed to ${selectedOption.value} the tag`);
        return response.json();
      })
      .then(() => {
        NotificationManager.success(`${selectedOption.value === 'delete' ? 'Tag deleted!' : selectedOption.value === 'change' ? 'Tag changed!' : 'Tag approved!'}`);
        fetchPostData(); // Refresh post data
      })
      .catch(error => {
        NotificationManager.error(`Error ${selectedOption.value === 'delete' ? 'deleting' : selectedOption.value === 'change' ? 'changing' : 'approving'} tag.`);
        console.error(`Error ${selectedOption.value} tag:`, error);
      })
      .finally(() => setIsProcessing(false));
  };

  const logComment = () => {
    fetch(`${process.env.REACT_APP_API_URL}/comment`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        post_id: selectedPostId,
        user_id: userId,
      }),
    })
      .then(response => response.json())
      .then(data => {
        let commentsBadge = document.getElementById('comments');
        let commentCount = commentsBadge.innerHTML.split(' ')[0];
        commentsBadge.innerHTML = `${parseInt(commentCount) + 1} <i class="bi bi-chat-dots"></i>`;
        commentsBadge.className = "badge bg-primary me-2";
      })
      .catch(error => {
        console.error('Error logging comment:', error);
      });
  };

  const logShare = () => {
    fetch(`${process.env.REACT_APP_API_URL}/share`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        post_id: selectedPostId,
        user_id: userId,
      }),
    })
      .then(response => response.json())
      .then(data => {
        console.log('Post shared:', data);
      })
      .catch(error => {
        console.error('Error sharing post:', error);
      });
  };

  const copyLinkToClipboard = () => {
    const url = `https://4construct.ro/homepage/index.php?p=newForum&postId=${postDetailsData.id_postare}`;
    logShare();
    navigator.clipboard.writeText(url).then(() => {
      NotificationManager.success('Link-ul postarii a fost copiat in clipboard!');
    }).catch(err => {
      NotificationManager.error('Nu s-a putut copia link-ul in clipboard!');
      console.error('Could not copy text: ', err);
    });
  };

  const fetchPostData = () => {
    fetch(`${process.env.REACT_APP_API_URL}/posts/${selectedPostId}`)
      .then(response => response.json())
      .then(data => {
        setPostDetailsData(data);
        fetchUserData(data.id_user);
      })
      .catch(error => console.error("Error fetching post data:", error));
  };

  const fetchUserData = (id_user) => {
    fetch(`${process.env.REACT_APP_API_URL}/users/${id_user}`)
      .then((response) => response.json())
      .then((data) => {
        setUserProfile(data);
        fetchHasCommented(userId, selectedPostId);
      })
      .catch((error) => {
        console.error("Error fetching user data:", error);
      });
  };

  const fetchLoggedUserData = () => {
    fetch(`${process.env.REACT_APP_API_URL}/users/${userId}`)
      .then((response) => response.json())
      .then((data) => {
        setLoggedUserData(data);
      })
      .catch((error) => {
        console.error('Error fetching logged user data:', error);
      });
  };

  const fetchHasCommented = (userId, postId) => {
    fetch(`${process.env.REACT_APP_API_URL}/hasCommentedOnPost/${userId}/${postId}`, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' }
    })
      .then(response => response.json())
      .then(data => {
        setHasCommented(data);
      })
      .catch(error => {
        console.error('Error checking if commented:', error);
      });
  };

  useEffect(() => {
    fetchPostData();
    fetchLoggedUserData();
  }, [selectedPostId]);

  if (!postDetailsData || !userProfile) return <div>Loading...</div>;

  let tags = [];
  let unapprovedTags = JSON.parse(postDetailsData.unapproved_tags);

  try {
    tags = JSON.parse(postDetailsData.tags);
  } catch (error) {
    console.error("Error parsing tags:", error);
  }

  return (
    <div className="post-details-container p-3">
      <div className="card post-details-card">
        <div className="d-flex flex-row justify-content-start align-items-center">
          <div className="btn" style={{ display: "flex", justifyContent: "center", alignItems: "center", margin: "5px", backgroundColor: "rgb(0, 195, 255)", border: "0px", color: "white" }} onClick={handleToggle}>
            <p style={{ marginBottom: "0px", marginRight: "5px" }}>Intoarce-te la forumul principal</p>
            <a href="#!" className="mr-3" style={{ display: "flex", justifyContent: "center", alignItems: "center", width: 30, height: 30, padding: 0, color: "white" }}>
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" className="bi bi-arrow-left-circle" viewBox="0 0 16 16">
                <path fillRule="evenodd" d="M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8m15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-4.5-.5a.5.5 0 0 1 0 1H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5z" />
              </svg>
            </a>
          </div>
        </div>
        <div className="card-body pt-0">
          <div className="d-flex align-items-top justify-content-between">
            <div className="d-flex align-items-top">
              <a href="#!" className="mr-3 mt-3 rounded-circle" style={{ minWidth: "50px" }} onClick={handleUserClick}>
                <img
                  src={userProfile.profile_picture}
                  className="rounded-circle"
                  style={{ maxWidth: "50px", height: "auto", width: "100%" }}
                  alt="User"
                />
                <small className="d-block text-muted">{userProfile.role}</small>
              </a>
              <div className="ms-3">
                <div>
                  <a href="#!" className="text-secondary" onClick={handleUserClick}>
                    {userProfile.username}
                  </a>
                  <small className="text-muted ms-2">
                    <ReactTimeAgo date={new Date(postDetailsData.timestamp)} locale="ro-RO" />
                  </small>
                </div>
                <small className="text-muted ms-2">
                  {userProfile.companie}
                </small>
                <h5 className="mt-1">{postDetailsData.titlu}</h5>
                <div className="mt-3">
                  <p className="post-text">{postDetailsData.text_postare}</p>
                </div>
              </div>
            </div>
            <div>
              <Badge bg="salmon" className="me-2">{postDetailsData.views} <i className="bi bi-eye"></i></Badge>
            </div>
          </div>
          <div className="mt-3 d-flex justify-content-between">
            <Stack direction={JSON.parse(postDetailsData.images).length > 0 ? "vertical" : "horizontal"} gap={2}>
              {tags.map((tag, index) => (
                <Badge key={`approved-${index}`} style={{ width: "min-content" }} bg="secondary">
                  {tag}
                </Badge>
              ))}
              {loggedUserData?.is_admin && unapprovedTags.map((tag, index) => (
                <div key={`unapproved-${index}`} style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                  <Badge style={{ width: "min-content" }} bg="warning">{tag}</Badge>
                  <Select
                    options={[
                      { value: 'approve', label: `Approve ${tag}` },
                      { value: 'delete', label: 'Delete' },
                      ...options
                        .filter(option => option.label !== tag) // Filter out the current tag
                        .map(option => ({ value: 'change', label: option.label })) // Set value to 'change' and label to tag
                    ]}
                    onChange={(selectedOption) => handleTagChange(tag, selectedOption)}
                    isDisabled={isProcessing}
                  />
                </div>
              ))}
            </Stack>
            {console.log("postDetailsData", postDetailsData)}
            {JSON.parse(postDetailsData.images).length > 0 ? <MyGallery postImages={postDetailsData.images} /> : null}
          </div>
          <NotificationContainer />
          <Stack direction="horizontal" gap={3} className="mt-3 mx-3 justify-content-center">
            <div style={{ flex: 1, display: 'flex', justifyContent: 'center' }} className="mx-1">
              <LikeButton initialLikes={postDetailsData.likes} postId={selectedPostId} userId={userId} />
            </div>

            <div style={{ flex: 1, display: 'flex', justifyContent: 'center' }} className="mx-1">
              <Badge id="comments" bg={hasCommented ? "primary" : "secondary"} style={{ width: "100%" }}>
                {postDetailsData.comment_count} <i className="bi bi-chat-dots"></i>
              </Badge>
            </div>

            {postDetailsData.is_public === 1 &&
              <div style={{ flex: 1, display: 'flex', justifyContent: 'center' }} className="mx-1">
                <OverlayTrigger
                  placement="top"
                  overlay={<Tooltip id="share-tooltip">Distribuie postare</Tooltip>}
                >
                  <Badge
                    bg="darkGray"
                    style={{ width: "100%", backgroundColor: "#475155" }}
                    className="badge-button"
                    onClick={copyLinkToClipboard}
                  >
                    <i className="bi bi-share"></i>
                  </Badge>
                </OverlayTrigger>
              </div>
            }
          </Stack>
        </div>
      </div>
      <MyCommentsSection postId={selectedPostId} userId={userId} logComment={logComment} />
    </div>
  );
};

export default PostDetails;
